<template>
	<span :class="['iconfont', _icon, _size] "></span>
</template>

<script>
	export default {
		name: 'bsf-icon',
		components: {
		},
		props: {
			icon:{
				type:String,
				default:''
			},
			size:{
				type:String,
				default:'normal'
			}
		},
		data() {
			return {
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				console.log()
			})
		},
		computed: {
			_icon(){
				return 'icon-' + this.icon
			},
			_size(){
				return 'font-' + this.size
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	@import "../../assets/lib/icon.less";
	.iconfont{
		&.font-large:before{
			font-size: larger
		}
		&.font-small:before{
			font-size: smaller
		}
	}
</style>


// WEBPACK FOOTER //
// icon.vue?6237d563